import React, { useMemo } from 'react';
import { Button } from 'shared-components/Button';
import { generateContactSupportStyles } from 'sections/ContactSupport/ContactSupportStyles';
import { useTheme } from '@emotion/react';
import { Box } from '@mui/material';

export function ContactSupport() {
    const theme = useTheme();
    const styles = useMemo(() => generateContactSupportStyles(theme), [theme]);

    return (
        <Box sx={styles.wrapper}>
            <Box component="p" sx={styles.title}>Can&apos;t find what you&apos;re looking for?</Box>
            <Button onClick={() => {
                window.parent.postMessage('callContactSupport', '*');
            }}
            >
                Contact Support
            </Button>
        </Box>
    );
}
